export default {
  rate: {
    levelName: '等级名称',
    requiredLevelName: '请输入等级名称',
    topScore: '等级上限分数（包含）',
    requiredTopScore: '请输入等级上限分数',
    bottomScore: '等级下限分数（包含）',
    requiredBottomScore: '请输入等级下限分数',
    performanceStrategy: '绩效策略',
    remarks: '等级说明',
    rectification: '整改',
    eliminate: '淘汰'
  },
  qualitativeProject: {
    qualitativeItemNo: '定性项目编号',
    qualitativeItemName: '定性项目名称',
    deptId: '所属部门',
    remarks: '备注',
    status: '启用',
    startUse: '启用',
    stopUse: '停用'
  },
  qualitativeFormula: {
    qualitativeFormulaNo: '定性公式编码',
    qualitativeFormulaName: '定性公式名称',
    status: '是否有效',
    remarks: '备注',
    release: '发布',
    unrelease: '取消发布',
    detail: '定性公式明细',
    addDetail: '添加定性公式',
    qualitativeItemNo: '定性项目',
    qualitativeItemName: '定性项目名称',
    weight: '权重（%）'
  },
  formulaConfig: {
    formulaName: '公式名称',
    purOfficeNo: '采购中心',
    effectiveDate: '生效日期',
    expirationDate: '失效日期',
    lastExecutionTime: '上次测评时间',
    rationFormulaName: '定量公式',
    qualitativeWeight: '定性权重(%)',
    qualitativeFormulaName: '定性公式',
    startUp: '启动',
    notStart: '不启动',
    timingTaskStatus: '定时任务状态',
    assessmentDate: '考核日期（号）',
    formulaNo: '公式编号',
    rationFormulaId: '定量公式',
    rationWeight: '定量权重(%)',
    qualitativeFormulaId: '定性公式',
    examinationCycle: '考核周期(个月)',
    remarks: '备注',
    monthly: '每月',
    th: '号',
    transferTitle: ['全部', '已选'],
    effectiveDateTip: '生效日期应小于失效日期!',
    expirationDateTip: '失效日期应大于生效日期!',
    effectiveDateTooltip: '生效日期:定时任务执行的开始时间，绩效年月的开始时间，到下个月才开始执行上个月的绩效!',
    expirationDateTooltip: '失效日期:定时任务执行的结束时间；失效日期所在年月不执行绩效!',
    implement: '手动执行',
    assessmentDatePlaceholder: '生成绩效日期，只能填写1-28号'
  },
  numberFormula: {
    rationFormulaName: '定量公式',
    qualifiedBatchWeight: '合格批率权重',
    qualifiedReceiptWeight: '合格收货率权重',
    expectedDeliveryWeight: '期望交期达成率权重',
    committedDeliveryWeight: '承诺交期达成率权重',
    priceDifferenceWeight: '目标价格差率权重',
    rationFormulaNo: '定量公式编号',
    toleranceDays: '允差天数',
    remarks: '备注'
  },
  supplierFormula: {
    purOfficeName: '采购中心',
    supOfficeName: '供应商',
    formulaId: '公式',
    setting: '设置公式'
  },
  performancequery: {
    searchPlaceholder: '输入供应商进行搜索',
    formulaId: '公式',
    purOfficeNo: '采购中心',
    adddate: '产生时间',
    supOfficeNo: '供应商',
    effectiveDate: '生效日期',
    expirationDate: '失效日期',
    revesion: '版本',
    performanceDate: '绩效时间',
    qualitativeScore: '定性绩效评分',
    qualitativeWeight: '定性绩效权重',
    rationScore: '定量绩效评分',
    rationWeight: '定量绩效权重',
    totalScore: '系统分数',
    adjustmentScore: '绩效分数',
    status: '状态',
    status1: '待发布',
    status2: '已发布',
    status3: '作废',
    purchaseUnitNo: '采购中心',
    adjustscore: '调整分数',
    release: '发布',
    cancel: '作废',
    see: '查看评分',
    recall: '撤回',
    releaseMessage: '是否确认发布？',
    cancelMessage: '是否确认作废？',
    recallMessage: '是否确认撤回？',
    systemScore: '系统评分',
    performanceScore: '绩效评分',
    determionationScore: '定性评分',
    quantitativeScore: '定量评分',
    totalRate: '总分',
    qualifiedBatchScore: '合格批率',
    qualifiedReceiptScore: '合格收货率',
    expectedDeliveryScore: '期望交期达成率',
    committedDeliveryScore: '承诺交期达成率',
    priceDifferenceScore: '目标价格差率'
  },
  qualitativescore: {
    searchPlaceholder: '输入公式进行搜索',
    formulaName: '公式',
    purOfficeName: '采购中心',
    performanceDate: '绩效时间',
    adddate: '产生时间',
    status: '是否评分',
    purchaseUnitNo: '采购中心',
    Y: 'Y',
    N: 'N',
    score: '评分',
    supOfficeName: '供应商',
    tableTitle: '定性评分明细',
    importTable: '导入',
    dialogTitle: '导入数据',
    fild: '上传附件',
    importTip: '仅允许上传"xls"或"xlsx"格式文件',
    download: '下载模板',
    templateName: '导入模板'
  }
}
